import email from "../assets/email.png"
import mobile from "../assets/mobile.png"

import javascript from "../assets/javascript.png"
import react from "../assets/react.png"
import eth from "../assets/eth.png"

import profile from "../assets/profile.png"
import circle from "../assets/circle.svg"
import logo from "../assets/logo-removebg.png"

const images = {
	email,
	mobile,
	javascript,
	react,
	eth,
	profile,
	circle,
	logo,
}

export default images
